export const apiUrl = process.env.REACT_APP_TITANIUM_URL;
export const baseApiUrl = process.env.REACT_APP_BASE_TITANIUM_URL;